import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class FetchPrices {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * FetchPrices constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Handle fetching the gifting prices from the API.
     *
     * @param {*} payload
     *
     * @returns {Promise<any>}
     */
    handle(payload) {
        let apiUrl = ApiEndpoints['gifting.prices.index'];

        return this.apiService.get(apiUrl);
    }
}
